<template>
    <a href="" class="defer a-inherit eventCard__card">
        <div class="sizing-container">
            <img :src="sizingImage" alt="" class="f1 sizing-placeholder">
            <div class="sizing-img" :style="{backgroundImage: `url(${image})`}"></div>
        </div>
        <div class="eventCard__card-footer">
            <div class="py-4px px-2">
                <div class="c-charcoal fw-light lh-15">{{ date }}</div>
                <h5 class="lh-15">{{ title }}</h5>
            </div>
            <div class="d-flex align-items-center py-1 px-2" :class="color">
                <div v-if="icon" class="mr-1 icon --small" :class="icon"></div>
                <div class="c-white fw-light fs-14">{{ category.label }}</div>
            </div>
        </div>
    </a>
</template>

<script>

    export default {
        name: 'EventCard',

        data() {
            return {
                images: [
                    'instagram-1.png',
                    'instagram-2.png',
                    'instagram-3.png',
                    'instagram-4.png',
                ],
                categories: [
                    {icon: 'music', label: 'Music', color: 'hanger-farm-purple'},
                    {icon: 'theatre', label: 'Theatre', color: 'furzey-gardens-blue'},
                    {icon: 'family', label: 'Family', color: 'day-opportunities'},
                    {icon: 'comedy', label: 'Comedy', color: 'minstead-green'},
                    {icon: 'film', label: 'Film', color: 'hanger-farm-red'},
                    {icon: 'paint', label: 'Activities', color: 'hanger-farm'},
                ]
            }
        },

        computed: {
            base() {
                return window.imgUrl;
            },
            sizingImage() {
                return this.base + '/svg/1-1-sizing.svg'
            },
            image() {
                return this.base + '/stock/' + _.sample(this.images);
            },
            date() {
                return '7 Nov 2019';
            },
            category() {
                return _.sample(this.categories);
            },
            color() {
                return `bg-${this.category.color}`;
            },
            icon() {
                return `--${this.category.icon}`;
            },
            title() {
                return 'Keith James: Message from The Gods';
            }
        }
    }

</script>
